var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#BDBDBD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.10156 8.5L11.6328 5.99219C11.7734 5.85156 11.7734 5.59375 11.6328 5.45312L11.0469 4.86719C10.9062 4.72656 10.6484 4.72656 10.5078 4.86719L8 7.39844L5.46875 4.86719C5.32812 4.72656 5.07031 4.72656 4.92969 4.86719L4.34375 5.45312C4.20312 5.59375 4.20312 5.85156 4.34375 5.99219L6.875 8.5L4.34375 11.0312C4.20312 11.1719 4.20312 11.4297 4.34375 11.5703L4.92969 12.1562C5.07031 12.2969 5.32812 12.2969 5.46875 12.1562L8 9.625L10.5078 12.1562C10.6484 12.2969 10.9062 12.2969 11.0469 12.1562L11.6328 11.5703C11.7734 11.4297 11.7734 11.1719 11.6328 11.0312L9.10156 8.5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDelete);
export default __webpack_public_path__ + "static/media/ic-delete.bbcfc83f86f91cd2c66e0bf17ebe4c62.svg";
export { ForwardRef as ReactComponent };